import { createRequestTypes } from '../utils';

export const FETCH_PHRASE_CPSR_CHAPTERS = createRequestTypes('phraseCpsrChapter/FETCH_PHRASE_CPSR_CHAPTERS');
